import type { PreProjetoDTO } from '../services/preProjetoService';

export const SEM_AREA = 'Sem área definida';

export const areaDe = (item: PreProjetoDTO) => item.areaAtuacao?.trim() || SEM_AREA;

/** `situacao`: '' (todos), 'DISPONIVEL' (ainda não escolhido) ou 'ESCOLHIDO'. `selecionadoPorId` é o id do usuário que escolheu. */
export type FiltrosPreProjeto = {
  area: string;
  exercicio: string;
  instituicaoId: string;
  situacao: '' | 'DISPONIVEL' | 'ESCOLHIDO';
  selecionadoPorId: string;
};

export const filtrosVazios: FiltrosPreProjeto = {
  area: '', exercicio: '', instituicaoId: '', situacao: '', selecionadoPorId: '',
};

export const passaNosFiltros = (item: PreProjetoDTO, filtros: FiltrosPreProjeto) =>
  (!filtros.area || areaDe(item) === filtros.area)
  && (!filtros.exercicio || String(item.exercicio) === filtros.exercicio)
  && (!filtros.instituicaoId || item.instituicaoId === filtros.instituicaoId)
  && (!filtros.situacao || (filtros.situacao === 'ESCOLHIDO') === (item.etapa === 'SELECIONADO'))
  && (!filtros.selecionadoPorId || String(item.selecionadoPorUsuarioId ?? '') === filtros.selecionadoPorId);

export const temFiltroAtivo = (filtros: FiltrosPreProjeto) =>
  Object.values(filtros).some((valor) => valor !== '');
